import { render, staticRenderFns } from "./ReserveDialog.vue?vue&type=template&id=99bcb162&scoped=true"
import script from "./ReserveDialog.vue?vue&type=script&lang=ts"
export * from "./ReserveDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReserveDialog.vue?vue&type=style&index=0&id=99bcb162&prod&lang=sass&scoped=true"
import style1 from "./ReserveDialog.vue?vue&type=style&index=1&id=99bcb162&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bcb162",
  null
  
)

export default component.exports